import { render, staticRenderFns } from "./courseSettlementManage.vue?vue&type=template&id=1b05d758&"
import script from "./courseSettlementManage.vue?vue&type=script&lang=js&"
export * from "./courseSettlementManage.vue?vue&type=script&lang=js&"
import style0 from "./courseSettlementManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports